module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson7/pages/lesson_7_4.pdf";